import { getImageObject, getLayerRecolorEnabled, getRefName } from '../utils';

export function SpriteLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    images: getImageObject(resAst, getRefName(layerAst.attrsMap.ref), colors)
  };
  layer.attrs.recolorEnable = getLayerRecolorEnabled(
    resAst,
    getRefName(layerAst.attrsMap.ref)
  );
  layer.attrs = {
    ...layerAst.attrsMap,
    ...layer.attrs,
    infinite: layerAst.attrsMap['playRepeat'] == 'true'
  };
}
